import { render } from "./PageHome.vue?vue&type=template&id=6622f72a"
import script from "./PageHome.vue?vue&type=script&lang=js"
export * from "./PageHome.vue?vue&type=script&lang=js"
script.render = render

export default script